const loadWistia = () => {
  let ev1 = document.createElement('script');
  ev1.src = 'https://fast.wistia.com/assets/external/E-v1.js';
  ev1.async = true;
  ev1.charset = 'ISO-8859-1'
  document.head.appendChild(ev1);
};

$(window).one('scroll', loadWistia);
